import { persistor } from '../app/store';
import { clearAllData } from '../features/auth/login';
import { clearParentInfo } from '../features/parentInfo/parentInfoSlice';
import { clearReenrolment } from '../features/reenrolment/reenrolmentSlice';
import { clearPayment } from '../features/payment/paymentSlice';
import { clearCampusPaymentState } from './campusPaymentCharges';

export const clearAllPersistedData = (dispatch) => {
  // Clear all Redux state
  dispatch(clearAllData());
  dispatch(clearParentInfo());
  dispatch(clearReenrolment());
  dispatch(clearPayment());
  
  // Clear persisted storage
  persistor.purge();
  
  // Clear localStorage items that are manually managed
  localStorage.removeItem('LoginToken');
  localStorage.removeItem('LogID');
  localStorage.removeItem('navState');
  clearCampusPaymentState();
};

export const logoutUser = (dispatch, navigate) => {
  clearAllPersistedData(dispatch);
  
  // Navigate to login page
  if (navigate) {
    navigate('/');
  }
};